<template>
<div class="wlx-teacher-appraiser">
    <div class="add-partner-enterprise-head clearfix">
        <div class="top-page-top fl">
            <span class="sp-top-text">
                <span>考评员遴选</span>
            </span>
        </div>
        <div class="fr btn-right">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="title" placeholder="请输考评员账号或姓名" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
    <!--审核弹窗-->
    <el-dialog title="提示" :visible.sync="dialogVisibleAudit" width="50%" :append-to-body="true" :before-close="cancel" :close-on-click-modal="false">
        <el-form label-width="200px">
            <el-form-item label="推荐单位意见：">
                <el-input type="textarea" v-model="unitOpinion" placeholder="请输入推荐单位意见"></el-input>
            </el-form-item>
            <el-form-item label="审核意见：">
                <el-input type="textarea" v-model="auditOpinion" placeholder="请输入审核意见"></el-input>
            </el-form-item>
            <el-form-item>
                <el-radio-group v-model="IsAuthentication">
                    <el-radio :label="1">通过</el-radio>
                    <el-radio :label="2">不通过</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
        <!-- <el-radio-group v-model="IsAuthentication">
        <el-radio :label="1">通过</el-radio>
        <el-radio :label="2">不通过</el-radio>
      </el-radio-group>
      <el-input type="textarea" class="textarea-class-input" v-if="IsAuthentication == 2" v-model="unitOpinion" placeholder="请输入不通过原因"></el-input> -->
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleAudit = false">取 消</el-button>
            <el-button type="primary" @click="shenhe">确 定</el-button>
        </span>
    </el-dialog>
    <el-table ref="multipleeeeTable" :data="list" tooltip-effect="dark" empty-text="" @selection-change="handleSelectionChange">
        <!-- <el-table-column prop="id" type="selection" width="55"></el-table-column> -->
        <el-table-column label="序号" type="index" width=""></el-table-column>
        <el-table-column prop="userName" label="账号" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="displayName" label="姓名" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="dateCreated" label="申报时间"></el-table-column>
        <el-table-column prop="education" label="学历"> </el-table-column>
        <el-table-column prop="occupation" label="职业" width=""></el-table-column>
        <el-table-column prop="phone" label="联系方式"> </el-table-column>
        <el-table-column prop="paperScore" label="考核最高分"> </el-table-column>
        <el-table-column prop="istrue" label="审核状态">
            <template slot-scope="scope">
                <span style="color:#05C94F" v-if="scope.row.IsPost == 1">审核通过</span>
                <span style="color:#E53939" v-if="scope.row.IsPost == 2">审核不通过</span>
                <span style="color:#2D82FF" v-if="scope.row.IsPost == 0">待审核</span>
            </template>
        </el-table-column>
        <el-table-column label="操作" width="240">
            <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" content="审核" placement="top-start">
                    <el-button icon="wl-icon-shenhe" size="mini" @click="audit(scope.row)" type="primary" title="审核"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="查看" placement="top-start">
                    <el-button icon="el-icon-view" size="mini" type="primary" @click="goView(scope.row.id)"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                    <el-button icon="el-icon-edit" size="mini" type="primary" @click="goEdit(scope.row.id)"></el-button>
                </el-tooltip>
            </template>
        </el-table-column>
    </el-table>
    <div class="u-page-con">
        <el-pagination background @size-change="handleSizeChange" @current-change="onPageChangeHandler" :current-page="pageIndex" :page-sizes="[10, 25, 50, 100, 200, 500, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-show="total > 0"></el-pagination>
    </div>
</div>
</template>

<script>
// import imageUpload from "components/imageUpload.vue";
export default {
    data() {
        return {
            list: [],
            SiteList: [],
            total: 0,
            pageSize: 10,
            pageIndex: 1,
            addNewNoticeVisible: false,
            editNoticeVisible: false,
            viewNoticeVisible: false,
            dialogVisibleAudit: false,
            /* -----------添加/修改弹框参数------------ */
            title: "",
            content: "",
            avatorUrl: "",
            newsType: 1,
            orderNumber: 0,
            pulishTime: "",
            /* --------------------------------------- */
            id: "",
            siteId: "",
            siteName: "",
            value: "",
            teacherId: "",

            materialInfo: [],
            imgsList: [],
            indexCount: 0,
            imgUrl: "",
            dialogVisiblePreviewResources: false,
            IsAuthentication: 1,
            unitOpinion: "",
            auditOpinion: "",
            TrainApplyId: "",
        };
    },
    props: {},
    // components: {
    //   imageUpload
    // },
    created() {
        this.getSessionStorage();
        this.school = this.$store.state.auth.userName;
        this.getTrainApplyList();
    },
    methods: {
        getTrainApplyList() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationTeacher/getTrainApplyList", {
                    page: this.pageIndex,
                    pageSize: this.pageSize,
                    name: that.title,
                    type: 2,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        this.list = rst.list;
                        this.total = rst.pagination.totalCount;
                        this.pageSize = rst.pagination.pageSize;
                        this.pageIndex = rst.pagination.pageIndex;

                        // 参数存储本地缓存
                        sessionStorage.setItem("wlx_TeacherAppraiser_pageIndex", that.pageIndex);
                        sessionStorage.setItem("wlx_TeacherAppraiser_pageSize", that.pageSize);
                        sessionStorage.setItem("wlx_TeacherAppraiser_title", that.title);
                    } else {
                        this.$message.warning(rst.msg);
                    }
                });
        },
        // 获取网页缓存信息
        getSessionStorage() {
            // 获取网页缓存信息
            var pageIndex = sessionStorage.getItem("wlx_TeacherAppraiser_pageIndex");
            var pageSize = sessionStorage.getItem("wlx_TeacherAppraiser_pageSize");
            var title = sessionStorage.getItem("wlx_TeacherAppraiser_title");

            if (pageIndex != null && pageIndex != undefined) {
                this.pageIndex = pageIndex;
            }
            if (pageSize != null && pageSize != undefined) {
                this.pageSize = pageSize;
            }
            if (title != null && title != undefined && title != "null") {
                this.title = title;
            }
        },
        cancel() {
            (this.dialogVisibleAudit = false), (this.unitOpinion = "");
            this.auditOpinion = "";
            this.IsAuthentication = "";
        },
        audit(row) {
            this.teacherId = row.userId;
            this.TrainApplyId = row.id;
            this.unitOpinion = row.unitOpinion;
            this.auditOpinion = row.auditOpinion;
            this.IsAuthentication = row.IsPost == 0 ? "" : row.IsPost;
            this.dialogVisibleAudit = true;
        },
        //审核
        shenhe() {
            var that = this;
            this.$http
                .post("/api/XOrg/AssociationTeacher/auditAppraiser", {
                    teacherId: that.teacherId,
                    type: that.IsAuthentication,
                    unitOpinion: that.unitOpinion,
                    auditOpinion: that.auditOpinion,
                    id: that.TrainApplyId,
                })
                .then((rst) => {
                    if (rst.code == 1) {
                        that.$message.success(rst.msg);
                        that.dialogVisibleAudit = false;
                        that.getTrainApplyList();
                    } else if (rst.code == -2) {
                        that.$message.warning(rst.msg);
                        that.dialogVisibleAudit = false;
                        that.getTrainApplyList();
                    } else {
                        that.dialogVisibleAudit = false;
                        that.$message.warning(rst.msg);
                    }
                });
        },
        // 查看
        goView(id) {
            this.$router.push({
                name: "applyTableDetail",
                params: {
                    userId: id,
                    userType: "2",
                },
            });
        },
        goEdit(id) {
            this.$router.push({
                name: "applyTableEdit",
                params: {
                    userId: id,
                    userType: "2",
                    url: "TeacherAppraiser",
                    pageIndex: String(this.pageIndex),
                    pageSize: String(this.pageSize),
                },
            });
        },
        onPageChangeHandler(page) {
            this.pageIndex = page;
            this.getTrainApplyList();
        },
        handleSizeChange(val) {
            this.pageIndex = 1;
            this.pageSize = val;
            this.getTrainApplyList();
        },
        handleSelectionChange(val) {
            this.ids = [];
            val.forEach((element) => {
                this.ids.push(element.Id);
            });
        },
        viewSchoolNews(row) {
            this.title = row.title;
            this.content = row.content;
            this.viewNoticeVisible = true;
        },
        search() {
            this.pageIndex = 1;
            this.getTrainApplyList();
        },
    },
};
</script>

<style lang="scss">
.wlx-teacher-appraiser {
    background: #fff;
    padding-bottom: 20px;

    .add-partner-enterprise-head {
        border-bottom: 1px solid #F0F0F0;
        height: 60px;

        .add-banner-btn,
        .delete-banner-btn {
            margin-top: 13px;
        }

        .delete-banner-btn {
            margin-right: 62px;
        }

        .top-page-top {
            border: none;
        }
    }

    .banner-page-con {
        padding: 20px 0;
        text-align: center;
    }

    .el-table thead {
        color: #05243D;
    }

    .btn-right {
        margin-top: 14px;
    }

    .export-button-a {
        color: #fff;
        background: #409eff;
        padding: 8px 15px;
        border-radius: 4px;
        margin: 0 10px;
    }
}
</style>
